import { FileUploader } from "@scrile/tools/dist";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";

const fileUploader = new FileUploader(config.s3UploadUrl, { chunkUpload: true });
const originalUpload = fileUploader.upload;
export const showDefaultUploadError = () => emitter.emit(EVENTS.STATUS_SHOW, { text: "File upload error" });

fileUploader.upload = function(fileList) {
  return originalUpload.call(fileUploader, fileList).catch(e => {
    showDefaultUploadError();
    throw e;
  });
};

export const calculateProgress = (total: number, loaded: number): number => {
  return Math.floor((loaded / total) * 100);
};

export default fileUploader;
